import styled from 'styled-components';

export const Container = styled.form`
	position: relative;
	width: 100%;
	height: 40px;
	padding: 8px 16px;
	border-radius: 6px;

	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-shrink: 0;

	background: ${({ theme }) => theme['warmgray-50']};
`;

export const Input = styled.input`
	width: calc(100% - 30px);
	height: 24px;

	background: ${({ theme }) => theme['warmgray-50']};
	border: none;

	color: ${({ theme }) => theme['font-secondary']};
	caret-color: ${({ theme }) => theme['orange-primary']};

	font-family: 'Pretendard';
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px;

	&::placeholder {
		color: ${({ theme }) => theme['font-tertiary']};
		font-family: 'Pretendard';
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 24px;
	}
`;

export const SubmitButton = styled.button`
	width: 20px;
	height: 20px;

	position: absolute;
	right: 20px;

	display: flex;
	justify-content: center;
	align-items: center;

	border: none;
	background-color: inherit;

	svg {
		width: 20px;
		height: 20px;
		flex-shrink: 0;
	}
`;

export const ClearButtonWrapper = styled.div`
	svg {
		width: 24px;
		height: 24px;
		flex-shrink: 0;
	}
`;
